import { IRailingConfig, IStringerType } from '@stair-craft/common/util';

import { STRINGER_INSET, STRINGER_THICKNESS, TETIVA_PROTRUSION } from '../../constants';

/**
 * Where a side board lies across the stair edge, as distances measured inward from the edge
 * (negative — outside). A kosour sits under the treads, set in from the edge; a тетива reaches
 * a little past the edge so the tread and riser ends stay housed inside it.
 */
export interface IBoardBand {
    readonly near: number;
    readonly far: number;
    /** Where a riser end stops, measured inward from the same edge. */
    readonly riserEnd: number;
}

export function boardBand(stringerType: IStringerType): IBoardBand {
    if (stringerType === 'kosour') {
        const far: number = STRINGER_INSET + STRINGER_THICKNESS;
        return { far, near: STRINGER_INSET, riserEnd: far };
    }
    return { near: -TETIVA_PROTRUSION, far: STRINGER_THICKNESS - TETIVA_PROTRUSION, riserEnd: 0 };
}

/**
 * How far in from the stair edge the railing line runs: over a тетива along the board's axis — the
 * balusters go into its top and the posts take its ends — yet no upright comes past the тетива's
 * outer face, where a neighbouring flight's board or the slab side may stand: a post wider than the
 * board sits flush with that face. Over a kosour, which lies under the treads, half a post in, so
 * the posts stay inside the stair edge and the balusters stand on the treads.
 */
export function railLineOffset(stringerType: IStringerType, railing: Pick<IRailingConfig, 'postWidth' | 'balusterWidth'>): number {
    const band: IBoardBand = boardBand(stringerType);
    const flush: number = Math.max(railing.balusterWidth, railing.postWidth) / 2 + band.near;
    return stringerType === 'tetiva' ? Math.max((band.near + band.far) / 2, flush) : railing.postWidth / 2;
}
